export default __webpack_public_path__ + "img/imagen.b43028c1.png";